// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import EditAutomation from './data'

export default function EditAutomationFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/EditAutomation">
      <EditAutomation {...props}>
        {children}
      </EditAutomation>
    </Flow>
  )
}
